import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from './../store';
import axios from 'axios';
import { MessageModal } from './component/modal/modal';

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from './component/btn/btn';
import List from './component/list/list';
import { LoadingModal } from './component/modal/modal';

import Chart from 'react-apexcharts';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from './component/search/search';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from './common/function';

import useWindowSize from './hook/useWindowSize'

function IntegrateSettlement() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { Rwidth, Rheight } = useWindowSize();

    // Redux State 예시
    const MyData = useSelector((state) => state.MyData);

    // 페이지네이션 / 공용 상태
    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);
    const [loading, setLoading] = useState(true);

    // 메시지 모달
    const [message, setMessage] = useState('');

    // ▼ (1) 가맹점 / 에이전트 리스트 State 분리
    const [merchantListData, setMerchantListData] = useState([]);
    const [agentListData, setAgentListData] = useState([]);

    // ▼ (2) table body에 쓰일 최종 데이터
    const [merchantCombineData, setMerchantCombineData] = useState([]);
    const [agentCombineData, setAgentCombineData] = useState([]);

    // 현재 선택된 row
    const [clickData, setClickData] = useState([]);

    // 테이블 리로딩 트리거
    const [reload, setReload] = useState(false);

    // 테이블 리렌더 트리거
    const [listState, setListState] = useState(false);

    // ----------------------------
    // 차트용 State (일별 / 월별)
    // ----------------------------
    const [dailyData, setDailyData] = useState([]);
    const [monthData, setMonthData] = useState([]);

    // ----------------------------
    // 기간 선택 (monthly: 일별 / yearly: 월별)
    // ----------------------------
    const [period, setPeriod] = useState('monthly');

    // ----------------------------
    // 년/월 select 동적 생성
    // ----------------------------
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;
    const yearList = [];
    for (let y = 2024; y <= currentYear; y++) {
        yearList.push(y);
    }
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);

    // 월 리스트 동적 생성
    const getMonthList = () => {
        const monthArray = [];
        const limit = selectedYear === currentYear ? currentMonth : 12;
        for (let m = 1; m <= limit; m++) {
            monthArray.push(m);
        }
        return monthArray;
    };
    const monthList = getMonthList();

    // 첫 로딩 시
    useEffect(() => {
        dispatch(change_Current_Location('정산달력'));
        dispatch(changeHeaderTitle({ mainTitle: '정산달력' }));

        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    // reload, period, selectedYear, selectedMonth 바뀔 때마다 리스트 호출
    useEffect(() => {
        getMerchantList();
        getAgentList();
    }, [reload, period, selectedYear, selectedMonth]);

    // ----------------------------
    // (2-1) 가맹점 정산 리스트
    // ----------------------------
    const getMerchantList = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/settlement/calandar', {
                withCredentials: true,
                params: {
                    // period에 따라 month 또는 year를 보낸다고 가정
                    month: period === 'monthly' ? `${selectedYear}-${String(selectedMonth).padStart(2, '0')}` : '',
                    year: selectedYear
                }
            });

            let tmp = response?.data;

            if (tmp?.code < 2000) {
                // 가맹점 데이터 저장
                setMerchantListData(tmp?.data ?? []);

                // (1) dailyData / monthData를 여기서 세팅
                if (period === 'monthly') {
                    // dailyData로 사용
                    const dailyResult = (tmp?.data ?? []).map(d => ({
                        date: d.date,
                        amt: d.agencyAmount // 그래프용 amt
                    }));
                    setDailyData(dailyResult);
                    setMonthData([]); // 초기화
                } else {
                    // monthData로 사용
                    const monthResult = (tmp?.data ?? []).map(d => ({
                        month: d.date?.slice(0, 7), // 예시로 date 중 YYYY-MM 부분만 추출
                        amt: d.agencyAmount
                    }));
                    setMonthData(monthResult);
                    setDailyData([]); // 초기화
                }
                setListState(e => !e);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    // ----------------------------
    // (2-2) 에이전트 정산 리스트
    // ----------------------------
    const getAgentList = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/settlement/agent/calandar', {
                withCredentials: true,
                params: {
                    year: selectedYear
                }
            });

            let tmp = response?.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                // 에이전트 데이터 저장
                setAgentListData(tmp?.data ?? []);
                setListState(e => !e);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    // ----------------------------
    // (3) 테이블용 가공 (가맹점)
    // ----------------------------
    useEffect(() => {
        let tableBodyData = [];
        if (merchantListData && merchantListData.length > 0) {
            for (let i = 0; i < merchantListData.length; i++) {
                let data = merchantListData[i];
                let rowData = [
                    { no: 2, text: dayjs(data.date).format("YYYY-MM-DD"), width: '80px', textAlign: 'center' },
                    { no: 3, text: changeNum(Number(data.trxAmount)), width: '90px', textAlign: 'right' },
                    { no: 3, text: changeNum(Number(data.trxCount)), width: '70px', textAlign: 'right' },
                    { no: 3, text: changeNum(Number(data.merchantAmount)), width: '90px', textAlign: 'right' },
                    { no: 3, text: changeNum(Number(data.agentAmount)), width: '90px', textAlign: 'right' },
                    { no: 3, text: changeNum(Number(data.agencyAmount)), width: '90px', textAlign: 'right' },
                    {
                        no: 3,
                        text: (
                            <img
                                src="/img/excel_img.png"
                                style={{
                                    height: '30px',
                                    padding: '0',
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    boxShadow: 'none',
                                    cursor: 'pointer'
                                }}
                                onClick={() => merchantExcel(data)} // (3) 가맹점 입금 엑셀
                                alt="merchant_excel"
                            />
                        ),
                        width: '70px',
                        textAlign: 'center'
                    },
                    {
                        no: 3,
                        text: (
                            <div>
                                {data.status === 'Y' ? (
                                    <div>정산완료</div>
                                ) : (
                                    <div
                                        className="btn btn-primary reg_btn"
                                        style={{
                                            width: '40px',
                                            height: '25px',
                                            padding: '0',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            boxShadow: 'none'
                                        }}
                                        onClick={() => merchantCheck(data.date)}
                                    >
                                        확인
                                    </div>
                                )}
                            </div>
                        ),
                        width: '70px',
                        textAlign: 'center'
                    }
                ];
                rowData.id = data.id;
                tableBodyData.push(rowData);
            }
        }
        setMerchantCombineData(tableBodyData);
    }, [merchantListData, reload]);

    // ----------------------------
    // (3) 테이블용 가공 (에이전트)
    // ----------------------------
    useEffect(() => {
        let tableBodyData = [];
        if (agentListData && agentListData.length > 0) {
            for (let i = 0; i < agentListData.length; i++) {
                let data = agentListData[i];
                let rowData = [
                    { no: 2, text: data.date, width: '80px', textAlign: 'center' },
                    { no: 3, text: changeNum(Number(data.amt)), width: '90px', textAlign: 'right' },
                    { no: 3, text: changeNum(Number(data.cnt)), width: '80px', textAlign: 'right' },
                    {
                        no: 3,
                        text: (
                            <img
                                src="/img/excel_img.png"
                                style={{
                                    height: '30px',
                                    padding: '0',
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    boxShadow: 'none',
                                    cursor: 'pointer'
                                }}
                                onClick={() => agentExcel(data)} // (3) 에이전트 입금 엑셀
                                alt="agent_excel"
                            />
                        ),
                        width: '70px',
                        textAlign: 'center'
                    },
                    {
                        no: 3,
                        text: (
                            <div>
                                {data.deposit_check === 'Y' ? (
                                    <div>정산완료</div>
                                ) : (
                                    <div
                                        className="btn btn-primary reg_btn"
                                        style={{
                                            width: '40px',
                                            height: '25px',
                                            padding: '0',
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            boxShadow: 'none'
                                        }}
                                        onClick={() => agentCheck(data.date)}
                                    >
                                        확인
                                    </div>
                                )}
                            </div>
                        ),
                        width: '70px',
                        textAlign: 'center'
                    }
                ];
                rowData.id = data.id;
                tableBodyData.push(rowData);
            }
        }
        setAgentCombineData(tableBodyData);
    }, [agentListData, reload]);

    // 테이블 Row 클릭
    const handleRowClick = (row) => {
        // 두 리스트 중 하나에 해당 row가 있을 수 있으니, 우선 merchantListData에서 찾고 없으면 agentListData에서 찾음
        let found = merchantListData.find((d) => d.id === row.id);
        if (!found) found = agentListData.find((d) => d.id === row.id);
        if (found) {
            setClickData(found);
        }
    };

    // 테이블 헤더 (가맹점)
    const tableHeaderDataMerchant = [
        { no: 1, text: '날짜', width: '80px', textAlign: 'center' },
        { no: 3, text: '승인액', width: '90px', textAlign: 'center' },
        { no: 3, text: '승인건수', width: '70px', textAlign: 'center' },
        { no: 3, text: '가맹점 정산액', width: '90px', textAlign: 'center' },
        { no: 3, text: '에이전트 수당', width: '90px', textAlign: 'center' },
        { no: 3, text: '매출', width: '90px', textAlign: 'center' },
        { no: 3, text: '입금엑셀', width: '70px', textAlign: 'center' },
        { no: 3, text: '확인여부', width: '70px', textAlign: 'center' }
    ];

    // 테이블 헤더 (에이전트)
    const tableHeaderDataAgent = [
        { no: 1, text: '날짜', width: '80px', textAlign: 'center' },
        { no: 3, text: '에이전트 수당', width: '90px', textAlign: 'center' },
        { no: 3, text: '에이전트 수', width: '80px', textAlign: 'center' },
        { no: 3, text: '입금엑셀', width: '70px', textAlign: 'center' },
        { no: 3, text: '확인여부', width: '70px', textAlign: 'center' }
    ];

    const merchantExcel = async (data) => {
        await axios.get(process.env.REACT_APP_API + "/api/settlement/deposit/excel", {
            withCredentials: true,
            params: {
                date: data.date,
            }
        }).then((response) => {
            let tmp = response?.data
            if (tmp?.code < 2000) {
                if (tmp?.data?.settlement?.length > 0) {
                    merchantExcelData(tmp?.data?.settlement ?? [], data.date)
                }
                else {
                    alert("엑셀 예정입니다.")
                }
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const merchantExcelData = (exData, date) => {
        let arr = []
        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]
                try {
                    arr.push({
                        "입금은행": t.bank,
                        "입금계좌": t.account,
                        "입금인성명": t.name,
                        "입금액": Number(t.amount),
                        "출금통장표시": t.company,
                        "입금통장표시": "빠른결제대행사",
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        Excel("가맹점", date, arr)
    }

    const agentExcel = async (data) => {
        console.log(data.date)
        await axios.get(process.env.REACT_APP_API + "/api/settlement/agent/deposit/excel", {
            withCredentials: true,
            params: {
                date: data.date,
            }
        }).then((response) => {
            let tmp = response?.data
            console.log(tmp)
            if (tmp?.code < 2000) {
                if (tmp?.data?.settlement?.length > 0) {
                    agentExcelData(tmp?.data?.settlement ?? [], data.date)
                }
                else {
                    alert("엑셀 예정입니다.")
                }
            }
        }).catch(error => {
            console.error(error);
        });
    }

    const agentExcelData = (exData, date) => {
        let arr = []
        if (exData) {
            for (let i = 0; i < exData.length; i++) {
                let t = exData[i]
                try {
                    arr.push({
                        "입금은행": t.bank,
                        "입금계좌": t.account,
                        "입금인성명": t.name,
                        "입금액": Number(t.amount),
                        "출금통장표시": t.company,
                        "입금통장표시": "빠른결제대행사",
                    })
                } catch (error) {
                    console.log(error);
                }
            }
        }
        Excel("에이전트", date, arr)
    }

    const merchantCheck = async (date) => {
        if (window.confirm("확인처리 하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + "/api/settlement/deposit-check", {
                date: date
            }, {
                withCredentials: true
            }).then((response) => {
                let tmp = response?.data
                if (tmp?.code < 2000) {
                    setReload(e => !e)
                }
            }).catch(error => {
                console.error(error);
            });
        }
    }

    const agentCheck = async (date) => {
        if (window.confirm("확인처리 하시겠습니까?")) {
            await axios.post(process.env.REACT_APP_API + "/api/settlement/agent/deposit-check", {
                date: date
            }, {
                withCredentials: true
            }).then((response) => {
                let tmp = response?.data
                console.log(tmp)
                if (tmp?.code < 2000) {
                    setReload(e => !e)
                }
            }).catch(error => {
                console.error(error);
            });
        }
    }

    const handleChangeYear = (e) => {
        const newYear = parseInt(e.target.value, 10);
        setSelectedYear(newYear);

        // 새 연도가 현재 연도이면, 이미 선택된 month가 현재 월보다 크면 조정
        if (newYear === currentYear && selectedMonth > currentMonth) {
            setSelectedMonth(currentMonth);
        }
    };

    // 월 변경
    const handleChangeMonth = (e) => {
        setSelectedMonth(parseInt(e.target.value, 10));
    };

    return (
        <div className="content dashboard" id="contents">
            {loading ? <LoadingModal /> : ''}
            <MessageModal message={message} />
            <div className="form_filter intro-y">
                <div className="main-title-wrap intro-y dashboard-graph" style={{ padding: '0' }}>
                    <div style={{ display: 'flex', gap: '10px' }}>
                        {/* 라디오버튼: 'monthly' => 일별, 'yearly' => 월별 */}
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '10px',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <label
                                    style={{
                                        marginRight: 5,
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <input
                                        type="radio"
                                        value="monthly"
                                        checked={period === 'monthly'}
                                        onChange={(e) => setPeriod(e.target.value)}
                                    />
                                    <span style={{ marginLeft: 3, paddingTop: 1 }}>월별</span>
                                </label>

                                <label
                                    style={{
                                        marginRight: 5,
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <input
                                        type="radio"
                                        value="yearly"
                                        checked={period === 'yearly'}
                                        onChange={(e) => setPeriod(e.target.value)}
                                    />
                                    <span style={{ marginLeft: 3, paddingTop: 1 }}>연도별</span>
                                </label>
                            </div>

                            {/* 년도 + 월 셀렉트 */}
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                }}
                            >
                                {/* ===== 년도 셀렉트 ===== */}
                                <select
                                    id="year_select"
                                    className="form-select"
                                    style={{
                                        height: '30px',
                                        padding: '0 10px',
                                        fontSize: '12px',
                                        width: '70px',
                                    }}
                                    value={selectedYear}
                                    onChange={handleChangeYear}
                                >
                                    {/* 필요하다면 reverse()로 순서 바꿀 수 있으나 
                                                                실제 value와 UI가 맞게 하려면 주의해야 함 */}
                                    {yearList
                                        .slice()
                                        .reverse()
                                        .map((y) => (
                                            <option key={y} value={y}>
                                                {String(y).substring(2)}년
                                            </option>
                                        ))}
                                </select>

                                {/* ===== 월 셀렉트 (월별일 때만) ===== */}
                                {period === 'monthly' && (
                                    <select
                                        id="month_select"
                                        className="form-select"
                                        style={{
                                            height: '30px',
                                            padding: '0 10px',
                                            fontSize: '12px',
                                            width: '70px',
                                        }}
                                        value={selectedMonth}
                                        onChange={handleChangeMonth}
                                    >
                                        {monthList.reverse().map((m) => (
                                            <option key={m} value={m}>
                                                {m}월
                                            </option>
                                        ))}
                                    </select>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* 매출 그래프 */}
            <div className="content-item">
                <div className="panel intro-y">
                    <div className="dailyStatsChart" style={{ width: '100%', height: '100%', padding: "10px 10px 0" }}>
                        <MainModal
                            data={period === 'monthly' ? dailyData : monthData}
                            period={period}
                            selectedYear={selectedYear}
                            selectedMonth={selectedMonth} />
                    </div>
                </div>
            </div>

            <div style={{ display: Rwidth >= 768 ? 'flex' : "block", gap: '10px' }}>
                {/* 가맹점 정산 */}
                <div className="intro-y box intro-padding" style={{ width: Rwidth >= 768 ? '60%' : "100%" }}>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>가맹점 정산</div>
                    <div className="div-flex-2 contents" style={{ gap: '20px' }}>
                        <div style={{ width: '100%' }}>
                            <List
                                tableHeaderData={tableHeaderDataMerchant}
                                tableBodyData={merchantListData?.length ?? 0} // 총 데이터수
                                filter_tableBodyData={merchantCombineData}
                                page={page}
                                setPage={setPage}
                                maxFirstPage={maxFirstPage}
                                listType={true}
                                listState={listState}
                                height={'600px'}
                                nonePage={false}
                                scrollState={true}
                            />
                        </div>
                    </div>
                </div>

                {/* 에이전트 정산 */}
                <div className="intro-y box intro-padding" style={{ width: Rwidth >= 768 ? '40%' : "100%" }}>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>에이전트 정산</div>
                    <div className="div-flex-2 contents" style={{ gap: '20px' }}>
                        <div style={{ width: '100%' }}>
                            <List
                                tableHeaderData={tableHeaderDataAgent}
                                tableBodyData={agentListData?.length ?? 0}
                                filter_tableBodyData={agentCombineData}
                                page={page}
                                setPage={setPage}
                                maxFirstPage={maxFirstPage}
                                listType={true}
                                listState={listState}
                                height={'600px'}
                                nonePage={false}
                                scrollState={true}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function MainModal({ data = [], period, selectedYear, selectedMonth }) {
    // 날짜 라벨 포맷 함수 ("2025-03-01" → "25-03-01")
    const formatDateLabel = (val) => {
        if (!val) return '';
        return val.slice(2);
    };

    // 오늘 날짜(시분초 제외)를 구하기 (예: '2025-04-25')
    const getTodayString = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    // period별 날짜/월을 Date 객체로 파싱 (year-month → YYYY-MM-01)
    const parseDate = (value, period) => {
        if (period === 'monthly') {
            // 'YYYY-MM-DD'
            return new Date(`${value}T00:00:00`);
        } else {
            // 'YYYY-MM' → 'YYYY-MM-01'
            return new Date(`${value}-01T00:00:00`);
        }
    };

    const todayStr = getTodayString();
    const todayDate = parseDate(todayStr, 'monthly'); // 'YYYY-MM-DD' 형태 기준

    // =======================
    // X축 rawCategories 생성
    // =======================
    let rawCategories = [];

    if (period === 'monthly') {
        // selectedYear, selectedMonth로 1일부터 말일까지
        const y = String(selectedYear);
        const m = String(selectedMonth).padStart(2, '0');
        const daysInMonth = new Date(+y, parseInt(m, 10), 0).getDate(); // 말일
        rawCategories = Array.from({ length: daysInMonth }, (_, i) => {
            const day = String(i + 1).padStart(2, '0');
            return `${y}-${m}-${day}`;
        });
    } else {
        // 연도 전체 1~12월
        const y = String(selectedYear);
        rawCategories = Array.from({ length: 12 }, (_, i) => {
            const mm = String(i + 1).padStart(2, '0');
            return `${y}-${mm}`;
        });
    }

    // X축 표시용 라벨
    const categories = rawCategories.map((val) => formatDateLabel(val));

    // Y값 생성 로직
    // 데이터 없으면 과거=0, 미래=null
    const seriesData = rawCategories.map((val) => {
        const found =
            period === 'monthly'
                ? data.find((item) => dayjs(item.date).format("YYYY-MM-DD") === val)   // 일별 data
                : data.find((item) => item.month === val); // 월별 data

        const currentDate = parseDate(val, period);

        if (found) {
            // **소수점 제거** (정수로 만들기)
            return parseInt(found.amt >= 0 ? found.amt : 0, 10);
            // 또는 Math.floor(parseFloat(found.amt))
        } else {
            // 데이터가 없으면 과거(오늘 포함)=0, 미래=null
            if (currentDate < todayDate) {
                return 0;
            } else {
                return null;
            }
        }
    });

    // ApexCharts 옵션
    const options = {
        chart: { height: 350, type: 'line' },
        dataLabels: { enabled: false },
        stroke: {
            width: 2,
            curve: 'smooth',
            connectNulls: false,
        },
        xaxis: {
            categories,
            labels: { rotate: -60, hideOverlappingLabels: true },
            title: {
                text: '매출그래프',
                style: { fontSize: '14px', fontWeight: 600 },
            },
        },
        yaxis: {
            min: 0,
            labels: {
                formatter: (value) =>
                    Math.floor(value)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            },
        },
        tooltip: {
            y: {
                formatter: (val) =>
                    val === null
                        ? ''
                        : val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원',
            },
        },
        legend: { position: 'top' },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    xaxis: { tickAmount: 4, labels: { rotate: -90 } },
                    yaxis: { show: false, labels: { show: false } },
                },
            },
        ],
    };

    const series = [
        {
            name: period === 'monthly' ? '일별 매출' : '월별 매출',
            data: seriesData,
        },
    ];

    return (
        <div className="marginTop30 modal_sty">
            <div style={{ height: 'auto', padding: '10px 0' }}>
                <Chart options={options} series={series} type="line" height={300} />
            </div>
        </div>
    );
}

const Excel = (type, date, excelData) => {
    const excelFileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const excelFileExtension = '.xlsx';
    const excelFileName = `${type} 입금엑셀_${date}`;

    const headerRow = [
        "입금은행", "입금계좌", "입금인성명", "입금액", "출금통장표시", "입금통장표시"
    ];

    const bodyRows = excelData.map((data) => ([
        data.입금은행, data.입금계좌, data.입금인성명, data.입금액, data.출금통장표시, data.입금통장표시,
    ]));

    const sheetData = [headerRow, ...bodyRows];
    const ws = XLSX.utils.aoa_to_sheet(sheetData);

    ws['!cols'] = Array(headerRow.length).fill({ wpx: 100 });

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const excelFile = new Blob([excelBuffer], { type: excelFileType });

    FileSaver.saveAs(excelFile, excelFileName + excelFileExtension);
};


export default IntegrateSettlement